import React from 'react';
import {cls } from '../../../packages/components';
import Asset from '../../../requests/apa/Asset';
import ProgressBar from '../../ProgressBar';
import Utils from '../../../utils/Utils';
import Translator from '../../../requests/apa/Translator';

const CardEpisode = ({episode, width, isFakeCard = false, percent = null, pbi = null, onClick = null, ribbonLength = null, indexCount = null, totalEpisodes}) => {
    const getAssetPlay = ()=>{
        return Asset.get('seasons_ribbon_option_button_play', '/images/ic_play.png')
    }

    const getTitleTruncate = (title) => {
        return Utils.cutPlayerString(title, 35, 30);
    }

    const resizeImage = (url) => {
        let urlNew = '';
        urlNew = `url('${url}?size&imwidth=254')`;

        return urlNew;
    }

    function withEllipsis(text, maxLength) {
        if(text.length > maxLength) {
            return text.slice(0, maxLength - 3).concat("...");
        }
        return text
    }

    const getPurchaseText = (pbi) => {
        let text = '';
        if (pbi && pbi.playButton && pbi.playButton.waspurchased === "1") return text;

        if (pbi && Array.isArray(pbi.buttons) && pbi.buttons.length !== 0) {
            const purchasableButtons = pbi.buttons.filter(btn => btn.waspurchased === '0'); //&& btn.price !== '0');
            const prices = purchasableButtons.map(btn => parseFloat(btn.price.replace(',', '.')));
            const minPrice = prices.length !== 0 ? Math.min(...prices) : null;
            if (minPrice) {
                const button = purchasableButtons.find(btn => btn.price.replace(',', '.') === minPrice.toString());
                const {currency, price} = button;
                text = withEllipsis(Translator.get('playing_ribbon_offerEpisode_label'), 25);
                text += ' ' + currency + price;
            }
        }
        return text;
    }

    const focusClass = indexCount > 0 && indexCount <= 4;

    const handleMouseEnter = (e) => {
        Utils.handleMouseEnter(e.target.offsetParent.id)
    }

    const getIdCard = (idx_temp) => {
      return `modal_episode_number_${Number.isInteger(idx_temp) ? idx_temp : null}`
    }

    const getDataSnLeftOrDataSnRight = (idx_temp, direction) => {
      const idxEpisodeCurrent = idx_temp;
      const idxInitEpisode = 0;
      const idxLastEpisode = totalEpisodes - 1;
      const idxEpisodeLeft = idxEpisodeCurrent - 1;
      const idxEpisodeRight = idxEpisodeCurrent + 1;

      if (direction === 'left') {
        return idxEpisodeCurrent === idxInitEpisode
          ? `#${getIdCard(idxLastEpisode)}`
          : `#${getIdCard(idxEpisodeLeft)}`
      }
      else if (direction === 'right') {
        return idxEpisodeCurrent === idxLastEpisode
          ? `#${getIdCard(idxInitEpisode)}`
          : `#${getIdCard(idxEpisodeRight)}`
      }

      return `#${getIdCard(idxEpisodeCurrent)}`
    }


    return (
        episode && <div
            style={{ width: width}}
            className={cls(`aaf-main-modal-options-episodes-main-container-main`)}>
            <a
                href="javascript:void(0)"
                className={cls('aaf-main-modal-options-episodes-main-container', (!isFakeCard && focusClass ? 'focusable': ''))}
                id={getIdCard(episode.idx_temp)}
                data-id={Number.isInteger(episode.idx_temp) ? episode.idx_temp : null}
                tabIndex={0}
                data-sn-right={getDataSnLeftOrDataSnRight(episode.idx_temp, 'right')}
                data-sn-left={getDataSnLeftOrDataSnRight(episode.idx_temp, 'left')}
                onClick = { () =>{
                    onClick && (typeof onClick === 'function') && onClick(episode);
                }}
                onMouseEnter={(e) => handleMouseEnter(e)}
                >
                <div className="aaf-main-modal-options-episodes-main-image">
                    <div
                        className={cls('aaf-main-modal-options-episodes-main-image-div', 'card-cover')}
                        style={{
                            backgroundImage: resizeImage(episode.image_still),
                            backgroundPosition: `${!isFakeCard ? 'center': 'center left'}`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className={cls('aaf-main-modal-options-episodes-main-image-div-progress-bar')}>
                            <div className={cls('aaf-main-modal-options-episodes-main-image-div-progress-children')}>
                                <ProgressBar percent ={percent}/>
                            </div>
                        </div>
                        <div className={cls('aaf-main-modal-options-episodes-main-image-div-purchase')}>
                            <p className= {cls('aaf-main-modal-options-episodes-main-image-div-purchase-text')}>{getPurchaseText(pbi)}</p>
                        </div>
                    </div>
                    <div className={cls('aaf-main-modal-options-episodes-main-image-title')}>
                        {!isFakeCard && <span>{getTitleTruncate(`${episode.episode_number}. ${episode.title_episode}`)}</span>}
                    </div>
                </div>
                <div className="aaf-main-modal-options-episodes-main-middle">
                    <img src={getAssetPlay()} className={cls('aaf-main-modal-options-episodes-main-middle-img')} alt={episode.idx_temp} />
                </div>
            </a>
        </div>
    );
};
export default CardEpisode;



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/components/CardEpisode.jsx